module.exports = __webpack_public_path__ + "html/banner_6adbd0b69ccd84f435df31b550ff0d58.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/banner.html
// module id = IU0M
// module chunks = 151